import { render, staticRenderFns } from "./HeaderOther.vue?vue&type=template&id=48f4dc3a&scoped=true&"
import script from "./HeaderOther.vue?vue&type=script&lang=js&"
export * from "./HeaderOther.vue?vue&type=script&lang=js&"
import style0 from "./HeaderOther.vue?vue&type=style&index=0&id=48f4dc3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f4dc3a",
  null
  
)

export default component.exports